var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login"},[_c('div',{staticClass:"loading"},[_c('div',{staticClass:"loading-img"},[_c('img',{attrs:{"src":"https://medin.oss-cn-shanghai.aliyuncs.com/file/images/cmhk/mylinkxiaolimao.gif","alt":"loading"}})])])])
}]

export { render, staticRenderFns }